import { protocolTypeCRUD } from "../../http";
import {
    PROTOCOL_TYPE_GET_REQUEST, PROTOCOL_TYPE_GET_SUCCESS, PROTOCOL_TYPE_GET_ERROR,
    PROTOCOL_TYPE_GET_BY_KEY_REQUEST, PROTOCOL_TYPE_GET_BY_KEY_SUCCESS, PROTOCOL_TYPE_GET_BY_KEY_ERROR,
    PROTOCOL_TYPE_ADD_REQUEST, PROTOCOL_TYPE_ADD_SUCCESS, PROTOCOL_TYPE_ADD_ERROR,
    PROTOCOL_TYPE_EDIT_REQUEST, PROTOCOL_TYPE_EDIT_SUCCESS, PROTOCOL_TYPE_EDIT_ERROR,
    PROTOCOL_TYPE_DELETE_REQUEST, PROTOCOL_TYPE_DELETE_SUCCESS, PROTOCOL_TYPE_DELETE_ERROR
} from "../constants/protocolTypeConstants";

export const getProtocolTypes = (args) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_TYPE_GET_REQUEST
        });

        const data = await protocolTypeCRUD.search(args);
        dispatch({
            type: PROTOCOL_TYPE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: PROTOCOL_TYPE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getProtocolTypeByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_TYPE_GET_BY_KEY_REQUEST
        });

        const data = await protocolTypeCRUD.get(id);
        dispatch({
            type: PROTOCOL_TYPE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: PROTOCOL_TYPE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addProtocolType = (data, args) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_TYPE_ADD_REQUEST
        });

        const response = await protocolTypeCRUD.create(data);
        await dispatch(getProtocolTypes(args));
        dispatch({
            type: PROTOCOL_TYPE_ADD_SUCCESS,
        });
        return response.id;
    } catch (error) {
        dispatch({
            type: PROTOCOL_TYPE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editProtocolType = (data, args) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_TYPE_EDIT_REQUEST
        });

        const response = await protocolTypeCRUD.edit(data);
        await dispatch(getProtocolTypes(args));
        dispatch({
            type: PROTOCOL_TYPE_EDIT_SUCCESS,
        });
        return response;
    } catch (error) {
        dispatch({
            type: PROTOCOL_TYPE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteProtocolType = (id, args) => async (dispatch) => {
    try {
        dispatch({
            type: PROTOCOL_TYPE_DELETE_REQUEST
        });

        const response = await protocolTypeCRUD.delete(id);
        await dispatch(getProtocolTypes(args));
        dispatch({
            type: PROTOCOL_TYPE_DELETE_SUCCESS,
        });
        return response;
    } catch (error) {
        dispatch({
            type: PROTOCOL_TYPE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
